var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoSymbolLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36.481,
    height: 25.6,
    viewBox: "0 0 36.481 25.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M694.245,389.965l-3.015,3.015-3.083-3.069,3.028-3.029-3.028-3.015-5.435-5.435-8.45,8.45,8.45,8.464,2.366-2.366,3.083,3.083-2.366,2.352a4.366,4.366,0,0,1-6.152,0l-8.464-8.45a4.366,4.366,0,0,1,0-6.152l8.464-8.464a4.366,4.366,0,0,1,6.152,0l5.435,5.435,3.015,3.029A4.366,4.366,0,0,1,694.245,389.965Z",
    transform: "translate(-669.912 -374.083)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M702.285,383.814l-8.45-8.464a4.366,4.366,0,0,0-6.152,0l-2.353,2.366,3.069,3.069,2.353-2.353,8.464,8.45-8.464,8.464L688.4,392.98l-3.083-3.069-3.015-3.029,3.015-3.015-3.069-3.069-3.015,3.015a4.341,4.341,0,0,0,0,6.152l3.015,3.015,3.083,3.083,2.353,2.352a4.366,4.366,0,0,0,6.152,0l8.45-8.45A4.341,4.341,0,0,0,702.285,383.814Z",
    transform: "translate(-667.081 -374.083)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSymbolLight);
export default __webpack_public_path__ + "static/media/logo_symbol_light.47c5668b.svg";
export { ForwardRef as ReactComponent };